import React from "react";
import { useEffect } from "react";
import { Col, Row, Card, Layout } from 'antd';
import { fetchCountryCode } from '../services/locationService';
import Wrapper from './Wrapper.tsx';

export default function HomePage() {

  useEffect(() => {
    const getCountryCode = async () => {
      try {
        const code = await fetchCountryCode();
        console.log("Country Code ", code);
      } catch (err) {
        console.log(err)
      }
    };
    getCountryCode();
  }, []);

  return (
    <Wrapper>
      <Layout>
        <Row gutter={[0, 24]} justify="space-evenly" className="middle-container">
          <Col xs={{ span: 22 }} sm={{ span: 22 }} md={{ span: 11 }}>
            <Card
              title="Pet Owner Platform - Admin Portal"
              bordered={true}
              bodyStyle={{ textAlign: 'left' }}
            >
              <p>This admin portal is setup to manage web application level configurations like:</p>
              <ul>
                <li>User Account Management</li>
                <li>Menu Management</li>
                <li>Preference Center - Consent Management</li>
                <li>Lookup data Management</li>
              </ul>
            </Card>
          </Col>
          <Col xs={{ span: 22 }} sm={{ span: 22 }} md={{ span: 11 }}>
            <Card
              title="Pet Owner Platform - Admin Portal"
              bordered={true}
              bodyStyle={{ textAlign: 'left' }}
            >
              <ul>
                <li>On the ticket page, please select "Animal Health - Pet Owner" for Application drop-down list to proceed.</li>
              </ul>
            </Card>
          </Col>
        </Row>
      </Layout>
    </Wrapper>
  );
}